export const GET_EDUCATION_SERVICE_KIND_REQUEST = 'GET_EDUCATION_SERVICE_KIND_REQUEST'
export const GET_EDUCATION_SERVICE_KIND_SUCCESS = 'GET_EDUCATION_SERVICE_KIND_SUCCESS'
export const GET_EDUCATION_SERVICE_KIND_ERROR = 'GET_EDUCATION_SERVICE_KIND_ERROR'

export const GET_EDUCATION_SERVICE_REQUEST = 'GET_EDUCATION_SERVICE_REQUEST'
export const GET_EDUCATION_SERVICE_SUCCESS = 'GET_EDUCATION_SERVICE_SUCCESS'
export const GET_EDUCATION_SERVICE_ERROR = 'GET_EDUCATION_SERVICE_ERROR'